/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconGithub = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-github',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.253 1A10.25 10.25 0 0 0 1 11.253c0 4.537 2.935 8.369 7.01 9.727.513.09.705-.218.705-.487 0-.243-.012-1.05-.012-1.91-2.577.475-3.243-.627-3.448-1.204-.115-.295-.615-1.205-1.051-1.448-.359-.192-.871-.667-.013-.68.808-.012 1.384.744 1.577 1.051.922 1.551 2.396 1.116 2.986.846.09-.666.359-1.115.653-1.371-2.28-.256-4.665-1.14-4.665-5.062 0-1.115.398-2.038 1.051-2.756-.102-.256-.461-1.307.103-2.717 0 0 .858-.269 2.82 1.051a9.514 9.514 0 0 1 2.563-.346c.871 0 1.743.115 2.563.346 1.96-1.333 2.82-1.05 2.82-1.05.563 1.409.204 2.46.102 2.716.654.718 1.05 1.628 1.05 2.756 0 3.934-2.396 4.806-4.677 5.062.372.32.692.936.692 1.897 0 1.371-.013 2.473-.013 2.82 0 .268.192.589.705.486a10.27 10.27 0 0 0 6.985-9.727A10.25 10.25 0 0 0 11.253 1Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconGithub.displayName = 'IconGithub';
export default IconGithub;
